<template>
    <div>
        <h5 class="heading-1 mb-4">
            <span>Regras de Acesso {{ acao == 'D' ? 'Permitidas' : '' }}</span>
        </h5>
        <b-row>
            <b-col sm="12">
                <app-tabela
                    idTabela="tblRegrasAcesso"
                    :itens="regrasAcesso"
                    :campos="campos"
                    :itensPorPagina="0"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="selecao" slot-scope="data">
                        <b-form-checkbox
                            :value="data.regraAcessoId"
                            v-model="regrasAcessoSelecionadas"
                        ></b-form-checkbox>
                    </template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import AplicacoesServicos from './AplicacoesServicos'

export default {
    props: {
        aplicacao: {
            type: Object
        },

        acao: {
            type: String
        }
    },

    data() {
        return {
            regrasAcesso: [],
            regrasAcessoSelecionadas: [],
            camposBase: [
                {
                    key: 'selecao',
                    label: ''
                },
                {
                    key: 'codRegraAcesso',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricaoRegraAcesso',
                    label: 'Regra de Acesso',
                    sortable: true,
                    filterable: true
                }
            ]
        }
    },

    methods: {
        obterRegrasAcesso() {
            this.$store.dispatch('addRequest')
            AplicacoesServicos.obterRegrasAcesso().then(response => {
                if (response) {
                    if (response.success) {
                        this.regrasAcesso = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter regras de acesso',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        if (this.acao == 'I') {
            this.obterRegrasAcesso()
        }
    },

    computed: {
        campos() {
            if (this.acao == 'D') {
                var camposClone = [...this.camposBase]
                camposClone.shift()
                return camposClone
            } else {
                return [...this.camposBase]
            }
        }
    },

    watch: {
        regrasAcessoSelecionadas() {
            this.$emit(
                'atualizarRegrasSelecionadas',
                this.regrasAcessoSelecionadas
            )
        },

        aplicacao() {
            this.regrasAcesso = this.aplicacao.regrasAcesso
            this.regrasAcessoSelecionadas = this.regrasAcesso.map(item => {
                return item.regraAcessoId
            })
        },

        acao(val, oldval) {
            if (oldval == 'D') {
                this.regrasAcessoSelecionadas = this.regrasAcesso.map(item => {
                    return item.regraAcessoId
                })
                this.obterRegrasAcesso()
            } else if ((oldval == 'A' || oldval == 'I') && this.aplicacao) {
                this.regrasAcesso = this.aplicacao.regrasAcesso
                this.regrasAcessoSelecionadas = this.regrasAcesso.map(item => {
                    return item.regraAcessoId
                })
            }
        }
    }
}
</script>
